import { render } from "./PageThree.vue?vue&type=template&id=24817f28&scoped=true"
import script from "./PageThree.vue?vue&type=script&lang=js"
export * from "./PageThree.vue?vue&type=script&lang=js"

import "./PageThree.vue?vue&type=style&index=0&id=24817f28&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24817f28"]])

export default __exports__